import React from 'react'

const AddDashboardModulePagesAccess = () => {
  return (
    <div>AddDashboardModulePagesAccess</div>
  )
}

export default AddDashboardModulePagesAccess